import Dashboard from '../views/Dashboard.vue';
import Login from '../views/Login.vue';
import query from './modules/query';
import logs from './modules/logs';
import issues from './modules/issues';
import apply from './modules/apply';
import sims from './modules/sims';

export default [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      can: 'view dashboard',
      breadcrumb: [
        { name: '主頁', route: "dashboard" }
      ]
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      guest: true,
      fillHeight: true,
    }
  },
  ...query,
  ...logs,
  ...issues,
  ...apply,
  ...sims,
  // {
  //   name: '404',
  //   path: '/404',
  //   component: NotFound,
  //   meta: {
  //     blankView: true,
  //   }
  // },
  // {
  //   path: '*',
  //   redirect: '/404'
  // }
]
